import { BODY_MEASUREMENT_CATALOG } from "@/lib/body-measurements";
import type { BodyMeasurementTrendConfig, WidgetConfig } from "@/lib/schema";
import { getWidgetModule } from "@/widgets/registry";
import type { WeekWidgetModule } from "@/widgets/types";
import { SettingsEditor } from "./SettingsEditor";
import { validate } from "./validate";
import { WeekView } from "./WeekView";

function defaults(existing: WidgetConfig[]): BodyMeasurementTrendConfig {
  const weekWidgets = existing.filter(
    (w) => getWidgetModule(w.kind)?.scope === "week",
  );
  const maxRow = weekWidgets.reduce((m, w) => Math.max(m, w.row), -1);
  const first = BODY_MEASUREMENT_CATALOG[0];
  return {
    id: crypto.randomUUID(),
    kind: "body-measurement-trend",
    // The measurement names the card: with one chart per measurement, two
    // widgets both called "Måltrend" would tell you nothing apart.
    label: first.label,
    row: maxRow + 1,
    column: 0,
    enabled: true,
    measurementType: first.key,
  };
}

export const bodyMeasurementTrend: WeekWidgetModule<BodyMeasurementTrendConfig> =
  {
    kind: "body-measurement-trend",
    label: "Måltrend",
    scope: "week",
    scoring: "none",
    defaults,
    validate,
    SettingsEditor,
    WeekView,
  };
